import { render, staticRenderFns } from "./ConfigCreditAnalysisLimiteSaldoDevedor.vue?vue&type=template&id=105ac135&"
import script from "./ConfigCreditAnalysisLimiteSaldoDevedor.vue?vue&type=script&lang=js&"
export * from "./ConfigCreditAnalysisLimiteSaldoDevedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports